import { render } from "./OrdersItem.vue?vue&type=template&id=0110ebc3"
import script from "./OrdersItem.vue?vue&type=script&lang=js"
export * from "./OrdersItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__